import ActionTypes from '../constants/action-types';
import { ChangeAccountAction } from '../types';

export default function (currencyCode: string): ChangeAccountAction {
  return {
    type: ActionTypes.CHANGE_ACCOUNT,
    payload: currencyCode,
  };
}
